<template>
  <card-collapsable
    :headerClass="'yellow darken-2 white--text'"
    dialogClass="assegna"
    :dialogProp="dialog"

    v-if="calciatoreInAsta"
  >
      <!-- :collapsed="false" -->
      

    <!-- always visible -->
    <template #visible>
      <v-icon class="white--text">add_moderator</v-icon>
    </template>

    <!-- card-title -->
    <template #title>Assegna calciatore</template>

    <!-- card-body -->
    <template #body>
      <calciatore-battuto :id="calciatoreInAsta" xLarge></calciatore-battuto>

      <!-- crediti -->
      <v-row justify="center" no-gutters class="mt-4">
        <v-col cols="5">
          <v-text-field
            class=""
            v-model="offerta"
            type="number"
            :value="minOfferta"
            :min="minOfferta"
            regular
            hide-details
            label="Costo calciatore"
            prepend-icon="monetization_on"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- seleziona squadra -->
      <v-list dense nav>
        <v-subheader>Seleziona squadra a cui assegnarlo</v-subheader>
        <div class="asta-assegna-lista">
          <v-list-item
            v-for="sq in asta_squadre_array"
            :key="sq.id"
            @click="select(sq.id)"
            :class="selectedClass(sq.id)"
            :disabled="squadraDisabled(sq.id)"
            class="squadra_list_item"
          >
            <v-list-item-avatar>
              <img :src="squadra(sq.id).pic" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                v-text="sq.name"
                class="squadra_name"
              ></v-list-item-title>
            </v-list-item-content>

            <v-list-item-avatar>
              <span class="crediti" v-show="squadra(sq.id).crediti != null"
                >{{ squadra(sq.id).crediti }}
              </span>
            </v-list-item-avatar>
          </v-list-item>
        </div>
      </v-list>
    </template>

    <!-- footer -->
    <template #actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded text @click="scarta()">Scarta</v-btn>
        <v-btn
          depressed
          rounded
          color="warning"
          class="pa-4 white--text"
          :loading="loading"
          @click="assegna()"
          :disabled="selected == null || squadraDisabled(selected)"
          >Assegna</v-btn
        >
        <!-- asta_choosers.indexOf(selected) == -1 ||
            offerta > squadra(selected).max_offerta -->
      </v-card-actions>
      <!-- error -->
      <div class="pa-2">
        <v-alert color="error" class="white--text" v-model="error">
          Offerta {{ errorValue }} non valida. Min: {{ minOfferta }} - Max:
          {{ maxOfferta }}
        </v-alert>
      </div>
    </template>
  </card-collapsable>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import CardCollapsable from "../common/CardCollapsable";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import CalciatoreBattuto from "../common/CalciatoreBattuto";

import Vuex from "vuex";

import * as Helpers from "../../js/helpers";

export default {
  mixins: [mixins, toast],
  components: { CardCollapsable, CalciatoreBattuto },
  data() {
    return {
      processing: false,
      error: false,
      errorValue: 0,
      offerta: Constants.OFFERTA.MINIMA,
      selected: null,
      loading: false,
    };
  },
  watch: {
    offerta(val) {
      this.error = false;
      this.errorValue = 0;
    },
    processing(val) {
      this.loading = val;
    },
    dialog(visible) {
      if (visible) {
        this.selected = null;
        this.offerta = Constants.OFFERTA.MINIMA;
      }
    },
  },
  mounted() {
    console.log("--> AstaAssegna ready.");
  },
  destroyed() {
    console.log("<-- AstaAssegna destroyed.");
  },
  methods: {
    selectedClass(id) {
      return {
        selected: this.selected == id && !this.squadraDisabled(id),
      };
    },
    squadraDisabled(id) {
      // let no_chooser = this.asta_squadre_active.indexOf(id) == -1;
      if (!_.find(this.asta_squadre_active, { id: id })) return true;

      let calciatore = this.calciatore(this.asta_round.calciatoreInAsta);
      let regole_lega = this.asta_info.lega;
      let crediti_min = this.offerta;
      let squadra = this.asta_squadre[id];
      let canJoinRound = Helpers.canJoinRound(
        regole_lega,
        squadra,
        calciatore,
        crediti_min
      );
      if (!canJoinRound) return true;

      // let crediti_insuff = this.offerta > this.squadra(id).max_offerta;
      let ruolo_calciatore = calciatore ? calciatore.ID_Ruolo : 0;
      // let ruoli_insuff =
      //   this.asta_info.lega.nRuoli.op !== "illimitati" &&
      //   this.acquistiPerRuolo(ruolo_calciatore, id) >=
      //     this.asta_info.lega.nRuoli[Helpers.ruoloLega(ruolo_calciatore)];
      // return no_chooser || crediti_insuff || ruoli_insuff;
      let acquistiCompletati = this.acquistiCompletati(ruolo_calciatore, id);
      return acquistiCompletati;
    },
    select(id) {
      this.selected = id;
    },
    async assegna() {
      if (this.processing) {
        return;
      }
      this.processing = true;
      if (this.offerta < this.minOfferta || this.offerta > this.maxOfferta) {
        this.error = true;
        this.errorValue = this.value;
        this.processing = false;
        return;
      }
      await this.wait(1000);
      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      let squadra_id = this.selected;
      let prezzo = this.offerta;
      db.assegnaCalciatore(calciatoreInAsta, squadra_id, prezzo)
        .then(this.astaLogAssign(calciatoreInAsta, squadra_id, prezzo))
        .then(this.wait(1000))
        .then(this.deactivateSquadra(squadra_id))
        .then(db.updateCounter())
        .then(db.resetRound(this.user_uid))
        .then((this.processing = false))
        // .then(db.emit("chooser")) // hack: perchè il chooser nn cambia => db nn emette evento
        .catch((err) => {
          console.log(err);
          db.resetRound(this.user_uid, true);
          this.processing = false;
        });
    },
    async scarta() {
      if (this.processing) {
        return;
      }
      this.processing = true;
      await this.wait(1000);
      let calciatoreInAsta = this.asta_round.calciatoreInAsta;
      db.scartaCalciatore(calciatoreInAsta)
        .then(this.astaLogScartato(calciatoreInAsta))
        .then(this.wait(1000))
        .then(db.updateCounter()) // altrimenti potrebbero imbrogliare
        .then(db.resetRound(this.user_uid))
        .then((this.processing = false))
        // .then(db.emit("chooser")) // hack: perchè il chooser nn cambia => db nn emette evento
        .catch((err) => {
          console.log(err);
          db.resetRound(this.user_uid, true);
          this.processing = false;
        });
    },
    squadra(id) {
      return this.asta_squadre[id];
    },
    // acquistiPerRuolo(squadra, ruolo) {
    //   return this.squadra(squadra).acquisti[ruolo] || 0;
    // },
  },
  computed: {
    calciatoreInAsta() {
      return this.asta_round.calciatoreInAsta;
    },
    minOfferta() {
      return Constants.OFFERTA.MINIMA; //Helpers.minOfferta(this.asta_settings.base_asta, this.calciatore(this.asta_round.calciatoreInAsta))
    },
    maxOfferta() {
      return this.squadra(this.selected)
        ? this.squadra(this.selected).max_offerta
        : Constants.OFFERTA.MINIMA;
    },
    dialog() {
      return this.admin && this.is_calciatore_in_asta && this.running;
    },
    ...Vuex.mapGetters([
      "asta_squadre_array",
      // "asta_choosers",
      "asta_squadre_active",
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";
.squadra_list_item.selected {
  background: var(--v-text-base);
  .squadra_name {
    color: white !important;
  }
}
.squadra_list_item.v-list-item--disabled {
  opacity: 0.3;
}
.crediti {
  width: 30px;
  height: 30px;
  font-size: 11px;
}
.asta-assegna-lista {
  height: 150px;
  overflow: auto;
}
</style>
